import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomFeaturesAPI from './useCustomFeaturesAPI';
import ClientListTable from './ClientListTable';
import styles from '../ClientList.scss';

const ClientListForm = () => {
  const [form, setForm] = useState({ clientName: '', featureTypes: [] });
  const { search, isSearching, featuresOps, searchResult } = useCustomFeaturesAPI();
  const { t } = useTranslation();
  const { clientName, featureTypes } = form;

  useEffect(() => {
    search({
      search: {
        clientName: '',
        featureTypes: []
      }
    });
  }, []);

  const handleFormChange = event => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const handleSearch = async event => {
    if (event) event.preventDefault();
    const params = {
      search: {
        clientName: clientName || '',
        featureTypes: featureTypes || []
      }
    };
    await search(params);
  };

  const handleRefresh = async () => {
    await search({
      search: {
        clientName: '',
        featureTypes: []
      }
    });
    setForm({ clientName: '', featureTypes: [] });
  };

  return (
    <>
      <form onSubmit={handleSearch}>
        <div className="form-row">
          <div className="form-group col-md-4">
            <label className="col-form-label" htmlFor="clientName">
              {t('features.ClientCustomFeatures.ClientList.table.company_name')}
            </label>
            <input
              onChange={handleFormChange}
              value={clientName}
              className="form-control"
              placeholder={t('features.ClientCustomFeatures.ClientList.table.company_name')}
              name="clientName"
              type="text"
            />
          </div>
          <div className="form-group col-md-4">
            <label className="col-form-label" htmlFor="featureTypes">
              {t('features.ClientCustomFeatures.ClientList.table.features')}
            </label>
            <select
              value={featureTypes}
              onChange={handleFormChange}
              className="form-control"
              placeholder={t('features.ClientCustomFeatures.ClientList.table.features')}
              name="featureTypes"
            >
              {featuresOps?.map(features => <option value={features}>{features}</option>)}
            </select>
          </div>
          <div className="form-group col-md-4 align-items-end">
            <div className="d-flex align-items-end h-full" style={{ gap: '1rem' }}>
              <button className="btn btn-primary" onClick={handleSearch}>
                {t('features.ClientCustomFeatures.ClientList.button.search')}
              </button>
              <button type="button" className="btn btn-outline-secondary" onClick={handleRefresh}>
                {t('features.ClientCustomFeatures.ClientList.button.refresh')}
              </button>
            </div>
          </div>
        </div>
      </form>
      <ClientListTable styles={styles} searchResult={searchResult} isSearching={isSearching} />
    </>
  );
};

export default ClientListForm;
